import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-labeled-fab-button-entry',
  templateUrl: './labeled-fab-button-entry.component.html',
  styleUrls: ['./labeled-fab-button-entry.component.scss'],
})
export class LabeledFabButtonEntryComponent implements OnInit, AfterViewInit {
  @ViewChild('myButton', { read: ElementRef , static: true }) button: ElementRef;

  @Input() color: string = '';
  @Input() label: string = '';
  @Input() preIconLabel: string = '';
  @Input() postIconLabel: string = '';
  @Input() iconName: string = '';
  @Output() click: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.button.nativeElement.setAttribute('data-desc', this.label);
  }

  propagateClick($event) {
    this.click.emit(true);
  }

}
